import React from 'react';

function PageError(props) {
    return <div className="">{props.error.message}</div>;
}

export default PageError;